import { render, staticRenderFns } from "./GbwappsArticle.vue?vue&type=template&id=7f74c676"
import script from "./GbwappsArticle.vue?vue&type=script&lang=js"
export * from "./GbwappsArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports